/**
 * Tutorial constants — step timing, styling, layout.
 */

export const TUTORIAL = {
  // Timing
  SUCCESS_HOLD_SECONDS: 1.0,       // pause after success before advancing
  COMPLETE_HOLD_SECONDS: 3.0,      // "TUTORIAL COMPLETE" display time

  // Movement threshold for "player moved" detection
  MOVE_THRESHOLD_PX: 80,

  // Opponent damage for offense tutorial steps
  HIT_DEMO_DAMAGE: 80,
  REALTIME_EDGEGUARD_DAMAGE: 50,
  KILL_DAMAGE: 120,

  // Player damage for incoming/DI/recovery demos
  INCOMING_PLAYER_DAMAGE: 70,
  STRATEGIC_DI_DAMAGE: 70,         // player damage for strategic DI step (strong knockback)
  BURST_ESCAPE_VOID_MARGIN: 120,   // px above voidY to place player for burst escape step

  // Energy/tier demo
  ENERGY_DEMO_CHARGE: 100,     // weapon charge for energy/tier demo

  // Wind override values
  WIND_DEMO_VALUE: 0.08,

  // Incoming step — opponent auto-fire parameters
  INCOMING_CHARGE_FRAMES: 60,      // 1 second charge before firing
  INCOMING_AIM_ANGLE: Math.PI * 0.7, // aim slightly upward toward player

  // Freeze-frame teaching durations (seconds)
  DI_FREEZE_SECONDS: 0.5,          // brief pause on hit before DI window
  RECOVERY_FREEZE_SECONDS: 0.5,    // brief pause after DI before recovery

  // UI layout
  PROMPT_Y: 120,           // vertical position of prompt text
  PROMPT_FONT_SIZE: 28,
  SUB_TEXT_FONT_SIZE: 18,
  PROGRESS_Y: 60,          // progress dots Y
  PROGRESS_DOT_RADIUS: 5,
  PROGRESS_DOT_GAP: 18,

  // Colors
  PROMPT_COLOR: 0xffffff,
  SUB_TEXT_COLOR: 0xaaaaaa,
  SUCCESS_COLOR: 0x44ff88,
  HINT_COLOR: 0xffaa00,
  PROGRESS_ACTIVE: 0x00ffff,
  PROGRESS_DONE: 0x44ff88,
  PROGRESS_PENDING: 0x333333,
} as const;
